import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ProjectBriefComponent } from '@/app/components/projects/project-development/tendering/shared/developer/project-brief/project-brief.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { IttApplicantReadOnlyFormComponent } from '@/app/components/projects/shared/tendering/ITT/itt-applicant-read-only-form/itt-applicant-read-only-form.component';
import { environment } from '@/app/environments/environment';
import { MessagesEnum } from '@/app/enums/message.enum';
import { HttpClient } from '@angular/common/http';
import { IttSectionDialogsComponent } from '@/app/components/projects/project-requests/requested-tendering/requested-itt/itt-section-dialogs/itt-section-dialogs.component';
import { MatDialog } from '@angular/material/dialog';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
import { RfpLabelService } from '@/app/components/projects/project-development/tendering/inivitation-to-tender/rfp-labels.service';

interface workPackges {
  id: number;
  name: string;
}
interface submittedData {
  submission_deadline: string;
  submission_address: string;
  contract_type_details: string;
  contract_type_attach: string;
  issue_date: string;
  clarification_deadline: string;
  contract_start_date: string;
  contract_award_notification: string;
  project_completion_date: string;
  name: string | null;
}

@Component({
  standalone: true,
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ProjectBriefComponent,
    MatExpansionModule,
    IttApplicantReadOnlyFormComponent,
    IttSectionDialogsComponent,
],
  selector: 'app-individual-itt-view',
  templateUrl: './individual-itt-view.component.html',
  styleUrls: ['./individual-itt-view.component.css'],
})
export class IndividualIttViewComponent implements OnInit {
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;

  storageBaseUrl = environment.storageUrl;
  baseUrl = environment.baseUrl;
  projectId: number | string;
  ittId: number;
  selectedWp: workPackges[] = [];
  submittedData: submittedData;
  docUrl: string | null = null;
  tendererResponse: any;
  projectIdentifier: string;
  projectName: string;
  submissionType: string = '';

  developerContractualTermsAttachments = []
  labels: any;
  isRFPorRFQ: string;

  constructor(
    private router: Router,
    private TenderingService: TenderingService,
    private route: ActivatedRoute,
    private http: HttpClient,
    public dialog: MatDialog,
    private getFileIconService: GetFileIconUtilityService,
    private rfpLabelService: RfpLabelService
  ) {}

  ngOnInit() {
    // Subscribe to route changes
    this.route.url.subscribe(() => {
      this.updateRFPorRFQFlag();
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
    });
    this.rfpLabelService.labels$.subscribe((labels) => {
      this.labels = labels;
    });
    this.projectId = this.route.snapshot.paramMap.get('projectId')!;
    this.ittId = +this.route.snapshot.paramMap.get('ittId')!;
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });
    this.TenderingService.setIttId(this.route.snapshot.paramMap.get('ittId')!);
    this.getITTSubmittedInitiationData();
    this.getIttTendererResponse();
  }

  updateRFPorRFQFlag() {
    const currentRoute = this.router.url.toLowerCase(); // Get full URL path
    if(currentRoute.includes('rfp')){
      this.isRFPorRFQ = 'RFP';
    }else if(currentRoute.includes('rfq')){
      this.isRFPorRFQ = 'RFQ'
    }
    console.log('isRFPorRFQ:', this.isRFPorRFQ);
  }

  openDialog(): void {
    this.dialog.open(this.dialogTemplate, {
      width: '89vw',
      height: 'fit-content',
      maxHeight: '90vh',
      disableClose: true,
      autoFocus: false,
    });
  }

  handleDialog() {
    this.getIttTendererResponse();
    this.dialog.closeAll();
  }

  handleClose() {
    if(this.isRFPorRFQ === 'RFP'){
      this.router.navigate(['/requests/rfp'],{
        queryParams:{
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier
        }
      });
    }else if(this.isRFPorRFQ === 'RFQ'){
      this.router.navigate(['/requests/rfq'],{
        queryParams:{
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier
        }
      });
    }
  }

  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
  
  handleApplySubmission(value: string) {
    if (value !== 'technical' && value !== 'commercial') {
      return false;
    }
    this.submissionType = value
    this.TenderingService.setIttId(this.ittId);
    this.openDialog();
  }

  // when user clicks on clarification button 
  navigateToClarification() {
    this.router.navigate([`projects/${this.projectId}/rfp/${this.ittId}/clarifications/applicant`]);
  }

  getITTSubmittedInitiationData() {
    return this.TenderingService.SubmittedInitiationData(
      this.projectId,
      this.ittId
    ).subscribe({
      next: (response: any) => {
        if (response) {
          this.selectedWp = response?.data?.selected_work_packages.map(
            (wp) => ({
              ...wp,
            })
          );
          this.submittedData = response?.data;
          this.TenderingService.setTenderType(response?.data.tendering_type);

          // Populating contract_type_attachments
          if (response?.data?.contractual_terms_attachments) {
            response?.data?.contractual_terms_attachments.forEach((file) => {
              this.developerContractualTermsAttachments.push({
                id: file?.id,
                name: file?.title,
                path: file?.file_path,
              });
            });
          }
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }

  getIttTendererResponse(){
    this.TenderingService.getIttTendererResponse(this.ittId).subscribe({
      next: (response) => {
        if(response?.meta?.success)
        {
          this.tendererResponse = response?.data;
        }
      },
      error: (error) => {
        if (error) {
          console.log(error);
        }
      }
    })
  }

  formatDate(input: string | null | undefined): string {
    const [date, time] = input.split('T');
    const [hours, minutes] = time.split(':').map(Number);

    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHour = hours % 12 || 12;

    return `${date} ${formattedHour}:${minutes
      .toString()
      .padStart(2, '0')} ${period}`;
  }

  downloadContractTermsDocument(event:Event, downloadLink: HTMLAnchorElement, id: number, filePath: string): void {
    if (!this.docUrl) {
      event.preventDefault();

      const parts = filePath.split('/');
      const _filePath = parts[parts.length - 1];
              
      const apiUrl = environment.apiUrl;
      const fullPath = `${apiUrl}/projects/${this.projectId}/tendering/itt/download-contractual-terms-document/${id}/${_filePath}`;

      // Fetch the image from the backend
      this.http.get(fullPath, { responseType: 'blob' }).subscribe((blob) => {
        this.docUrl = window.URL.createObjectURL(blob); // Convert blob to URL
        downloadLink.click();
      });
    } else {
      event.preventDefault();
      window.open(this.docUrl, '_blank');
      this.docUrl = null;
    }
  }

  viewFile(filePath: string): void {
    const fullPath = `${this.storageBaseUrl}${filePath}`;

    // Open the file in a new tab
    const newTab = window.open(fullPath, '_blank');
    if (!newTab) {
      console.warn(MessagesEnum.POPUP_BLOCKED);
    }
  }
}
